import { Card, CardBody, Divider } from '@heroui/react';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { type TabProps } from '../../types';

import { EmailNotifications, MessagingNotifications } from './components';

interface NotificationsTabProps extends TabProps {}

interface NotificationFormValues {
  email: {
    orderUpdates: string;
    systemAlerts: string;
    security: string;
  };
  sms: {
    orderUpdates: string;
    emergencyAlerts: string;
  };
}

export const NotificationsTab: React.FC<NotificationsTabProps> = ({
  mode,
  supplier,
}) => {
  const methods = useForm<NotificationFormValues>({
    defaultValues: {
      email: {
        orderUpdates: '',
        systemAlerts: '',
        security: '',
      },
      sms: {
        orderUpdates: '',
        emergencyAlerts: '',
      },
    },
  });

  return (
    <FormProvider {...methods}>
      <Card>
        <CardBody className="p-6">
          <div className="flex flex-col gap-6">
            <div>
              <h2 className="text-xl font-semibold text-foreground mb-2">
                Notifications
              </h2>
              <p className="text-foreground-500">
                By inserting recipients into the fields below, the supplier will
                automatically start receiving orders via that particular
                channel.
              </p>
            </div>

            <EmailNotifications />

            <Divider className="my-2" />

            <MessagingNotifications />
          </div>
        </CardBody>
      </Card>
    </FormProvider>
  );
};
